
<div
  [class.participant-container--active]="isSelected$ | async"
  class="participant-container"
  >
  @if (user$ | async; as user) {
    <button
      [disabled]="isDisabled$ | async"
      [class.participant--active]="isSelected$ | async"
      class="participant"
      (click)="onSelectParticipant()"
      >
      <mat-icon class="participant__image" [svgIcon]="imageSrc" data-testid="participant-image"></mat-icon>
      <div class="participant__details">
        <h3 class="participant__name" data-private>{{ user.displayName }}</h3>
        @if(!user.checkInStatus?.isStarted) {
          <span class="participant__role">{{ user.userRoleCode | role }}</span>
        } @else {
          <span class="participant__status">
            {{ user.checkInStatus?.isCompleted ? '(Checked In)' : '(Checking In)' }}
          </span>
        }
      </div>
    </button>
  }
</div>

